<campus-elevated-card (click)="cardAction && clickAction(cardAction)">
  @if (learningAreaName) {
    <campus-card-overline-head data-cy="task-card-learning-area">
      {{ learningAreaName }}
    </campus-card-overline-head>
  }
  <campus-card-headline data-cy="task-card-name">{{ name }}</campus-card-headline>

  <campus-card-hint data-cy="task-card-hint">
    @if (isFinished) {
      <div class="[ absolute right-none -m-3xs ] [ success ] [ corner-full ]">
        <div data-cy="task-card-hint-finished" class="[ surface clip-check icon-size-m ]"></div>
      </div>
    } @else {
      @if (isUrgent) {
        <campus-svg
          data-cy="task-card-hint-urgent"
          svgImage="urgent"
          class="[ absolute right-none -m-xs ][ icon-size-l ]"
        ></campus-svg>
      }
    }
  </campus-card-hint>


  <campus-card-text data-cy="task-card-text">
    <div class="[ stack ]">
      <div class="[ cluster label-small ]">
        <div>
          @if (required) {
            <div class="[ inline-flex flex-nowrap items-center gap-3xs ]" data-cy="task-card-required">
              {{ required.total }} {{ required.label }}
              @if (required.total) {
                <campus-status-progress
                  [progress]="requiredProgress"
                  color="primary"
                ></campus-status-progress>
              }
            </div>
          }

          @if (notRequired) {
            <div
              class="[ inline-flex flex-nowrap items-center gap-3xs ]"
              data-cy="task-card-optional"
              >
              {{ notRequired.total }} {{ notRequired.label }}
              @if (notRequired.total) {
                <campus-status-progress
                  [progress]="notRequiredProgress"
                  color="warn"
                ></campus-status-progress>
              }
            </div>
          }
        </div>
      </div>
      <div [ngClass]="isUrgent ? ['weight-extrabold'] : ['weight-regular', 'text-lowercase']" data-cy="task-card-date">
        {{ dateLabel }}
      </div>
    </div>
  </campus-card-text>

  <campus-card-action-area data-cy="task-card-actions" class="[ cluster ]">
    <div class="[ justify-end ]">
      @for (action of inlineCardActions; track action) {
        <button
          inline-button
          (click)="clickAction(action)"
          [leadingIcon]="action.icon"
          >
          {{ action.label }}
        </button>
      }
      @for (action of primaryCardActions; track action) {
        <button
          elevated-button
          (click)="clickAction(action)"
          [leadingIcon]="action.icon"
          >
          {{ action.label }}
        </button>
      }
    </div>
  </campus-card-action-area>

  <campus-card-progress data-cy="task-card-progress">
    <campus-segmented-progress-bar
      [totalSegments]="totalSegments"
      [filledSegments]="filledSegments"
    ></campus-segmented-progress-bar>
  </campus-card-progress>
</campus-elevated-card>
